import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { AppState } from 'state'

export interface NftFavorites {
  status: 'idle' | 'loading' | 'failed'
  favoriteMode: boolean
  favorites: string[]
}

const initialState: NftFavorites = {
  status: 'idle',
  favoriteMode: false,
  favorites: []
}

export const nftFavoritesSlice = createSlice({
  name: 'nftFavorites',
  initialState,
  reducers: {
    addToFavorites(state, action: PayloadAction<string>) {
      state.favorites = [...state.favorites, action.payload]
    },
    removeFromFavorites(state, action: PayloadAction<string>) {
      const newArray = [...state.favorites]
      const index = newArray.indexOf(action.payload)

      if (index > -1) {
        newArray.splice(index, 1)
      }

      state.favorites = [...newArray]
    },
    setFavoriteMode(state, action: PayloadAction<boolean>) {
      state.favoriteMode = action.payload
    }
  }
})

export const selectNftFavorites = (state: AppState) => state.nftFavorites
export const { addToFavorites, removeFromFavorites, setFavoriteMode } = nftFavoritesSlice.actions

export default nftFavoritesSlice.reducer
